export default __webpack_public_path__ + "static/media/scanToStore.6d2beb76.svg";